import { useProcurifyIntl } from '@webapp/hooks'
import { messages } from './messages'

interface UseIsStripeSunsetResult {
  isStripeSunset: boolean
  stripeSunsetHelperText: string
}

/**
 * Returns whether Stripe spending card actions should be disabled,
 * along with a helper text string for tooltips/disabled states.
 *
 * With the Stripe integration switch removed no domain can be in the Stripe
 * sunset state, so this is always false. The hook is retained until the Stripe
 * scaffolding is removed in a later phase.
 */
export const useIsStripeSunset = (): UseIsStripeSunsetResult => {
  const intl = useProcurifyIntl()

  return {
    isStripeSunset: false,
    stripeSunsetHelperText: intl.formatMessage(messages.stripeSunsetHelperText),
  }
}
